import React, { useState, useEffect, useContext } from 'react';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionType, InteractionStatus, InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest, b2cPolicies } from "../authConfig";
import { toast } from 'react-toastify';
function useLogout() { //filter report data by selected Audit End Dates
    //const [filteredData, setFilteredData] = useState([]); //use filteredData as temp arr
    //const [counter, setCounter] = useState(0);
    const { instance: activeInstance, accounts: activeAccounts, inProgress: activeInProgress } = useMsal();
    const [signOutResult, setSignOutResult] = useState(false);
    const [throwRequestError, setThrowRequestError] = useState(false);



       function handleSignOut(signOutRequested) {
           if (signOutRequested === true) {

               //const accounts = instance.getAllAccounts();
               console.log("signout requested - ", activeAccounts.length);
               //const acc = instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn).idTokenClaims;
               //console.log("account found - ", acc);
               //1. blacklist token
               let resultHit = false;
               if (activeAccounts.length > 0) {
                   const fetchToken = async () => {
                       await activeInstance.acquireTokenSilent({ loginRequest, account: activeInstance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) })
                           .then(result => {
                               console.log("hit result", result.idToken);
                               resultHit = true;
                               const requestLogout = async () => {
                                   let retry = 5;
                                   let response = null;
                                   let counter = 1;
                                   let timeout = (delay) => new Promise(resolve => setTimeout(resolve, delay));
                                   while (retry > 0) {
                                       if (retry < 5) {
                                           let d = 2000 * counter;
                                           await timeout(d);
                                       }
                                       await fetch(process.env.REACT_APP_BACK_URL + '/api/Auth/SignOut', {
                                           method: 'GET',
                                           mode: 'cors',
                                           headers: {
                                               'Content-Type': 'application/json',
                                               'Authorization': 'Bearer ' + result.idToken,
                                           },

                                       }).then(res => {
                                           if (res.ok) {
                                               retry = 0;
                                               console.log("logout call successful");
                                               //activeInstance.logoutRedirect(); // logout
                                               setSignOutResult(true);
                                               return;
                                           }
                                           if (retry > 1) {
                                               retry--;
                                               counter++;
                                               return;
                                           }
                                           if (retry <= 1) {
                                               //toast.error("There was an issue logging out. Please try again.", {
                                               //    position: "bottom-center",
                                               //    theme: "colored",
                                               //    autoClose: false,
                                               //    closeOnClick: true,
                                               //    toastId: "logoutError"
                                               //})

                                               //activeInstance.logoutRedirect(); // logout
                                               setSignOutResult(true);
                                               retry = 0;
                                               return;
                                           }


                                           //}).then((response) => {
                                           //    //logout
                                           //    console.log("hit logout response call");
                                       }).catch((error) => { console.log(error) })

                                   }



                               }



                               requestLogout();
                           }).catch((error) => {
                               console.log(error) //token expired/is not valid => user is redirected to login page
                               if (error instanceof InteractionRequiredAuthError) {
                                   activeInstance.acquireTokenRedirect({ loginRequest, account: activeInstance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) });
                               }

                           });
                   }
                   fetchToken();
               }
               console.log("end result - ", resultHit);
           }

     


    }


    function handleSignOutInactive(signOutRequested, instance) {
        if (signOutRequested === true) {

            const accounts = instance.getAllAccounts();
            console.log("signout requested - ", accounts.length);
            //const acc = instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn).idTokenClaims;
            //console.log("account found - ", acc);
            //1. blacklist token
            let resultHit = false;
            if (accounts.length > 0) {
                const fetchToken = async () => {
                    await instance.acquireTokenSilent({ loginRequest, account: instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) })
                        .then(result => {
                            console.log("hit result", result.idToken);
                            resultHit = true;
                            const requestLogout = async () => {
                                let retry = 5;
                                let response = null;
                                let counter = 1;
                                let timeout = (delay) => new Promise(resolve => setTimeout(resolve, delay));
                                while (retry > 0) {
                                    if (retry < 5) {
                                        let d = 2000 * counter;
                                        await timeout(d);
                                    }
                                    await fetch(process.env.REACT_APP_BACK_URL + '/api/Auth/SignOut', {
                                        method: 'GET',
                                        mode: 'cors',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + result.idToken,
                                        },

                                    }).then(res => {
                                        if (res.ok) {
                                            retry = 0;
                                            console.log("logout call successful");
                                            //instance.logoutRedirect(); // logout
                                            setSignOutResult(true);
                                            return;
                                        }
                                        if (retry > 1) {
                                            retry--;
                                            counter++;
                                            return;
                                        }
                                        if (retry <= 1) {
                                          
                                            retry = 0;
                                            //instance.logoutRedirect();
                                            setSignOutResult(true);
                                            return;
                                        }


                                        //}).then((response) => {
                                        //    //logout
                                        //    console.log("hit logout response call");
                                    }).catch((error) => { console.log(error) })

                                }



                            }



                            requestLogout();
                        }).catch((error) => {
                            console.log(error) //token expired/is not valid => user is redirected to login page
                            if (error instanceof InteractionRequiredAuthError) {
                                instance.acquireTokenRedirect({ loginRequest, account: instance.getAllAccounts().find((account) => account.idTokenClaims['tfp'] === b2cPolicies.names.signUpSignIn) });
                            }

                        });
                }
                fetchToken();
            }
            console.log("end result - ", resultHit);
        }




    }






    return { handleSignOut, handleSignOutInactive, signOutResult };
}
export default useLogout;